import React from "react";
import { Link, NavLink } from "react-router-dom";
import {WalletMultiButton} from "@solana/wallet-adapter-react-ui";
import { useWallet } from '@solana/wallet-adapter-react';
import { Connection, PublicKey, Transaction, SystemProgram } from '@solana/web3.js';
import "./ShlotMachineNavbar.css"

const Navbar = () => {
    const publicKey = useWallet().publicKey;
    return (
        <nav className="navbar">
            <ul className="navbar-list">
                <li className="navbar-item">
                    <WalletMultiButton />
                </li>
                <li className="navbar-item">
                    <NavLink
                        to="/"
                        className={({ isActive }) => (isActive ? "active" : "")}
                    >
                        🎰 Shlot Machine 🎰
                    </NavLink>
                </li>
                <li className="navbar-item">
                    <NavLink
                        to="/transactions"
                        className={({ isActive }) => (isActive ? "active" : "")}
                    >
                        View Transactions
                    </NavLink>
                </li>
                {publicKey && publicKey.toBase58() == '5Je5czeRdZ6WnbjQDhK8C6vNnYowh7TjchxAE3AyBhZL' &&
                <li className="navbar-item">
                    <NavLink
                        to="/all-transactions"
                        className={({ isActive }) => (isActive ? "active" : "")}
                    >
                        All Transactions
                    </NavLink>
                </li>
                }
            </ul>
        </nav>
    );
};

export default Navbar;